import { gql } from '@apollo/client'
import { EHR_APPOINTMENT_FIELDS } from '@src/graphql/fragments/ehrAppointment'

const APPLY_FREE_APPOINTMENT = gql`
  ${EHR_APPOINTMENT_FIELDS}
  mutation applyFreeEhrAppointment($insuranceProvider: String) {
    applyFreeEhrAppointment(insuranceProvider: $insuranceProvider) {
      ...EhrAppointmentFields
    }
  }
`

export default APPLY_FREE_APPOINTMENT
